// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GVBe","content":"styles_content__2qDEB","row":"styles_row__2DfyA","footer":"styles_footer__t7a1j","phraseLength":"styles_phraseLength__1zEbt"};